// auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, catchError, Observable, tap, throwError } from 'rxjs';
import { defaultConfig } from '../API-Urls/urls';
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.url;

  private phoneSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  phone$ = this.phoneSubject.asObservable();

  constructor(private http: HttpClient) {
    const storedPhone = this.getPhoneFromStorage();
    this.phoneSubject.next(storedPhone);
  }

  setPhone(phone: string) {
    const expiryTime = Date.now() + 6 * 60 * 60 * 1000;
    sessionStorage.setItem('phone', phone);
    sessionStorage.setItem('phoneExpiry', expiryTime.toString());
    this.phoneSubject.next(phone);
  }

  getPhoneFromStorage(): string | null {
    const phone = sessionStorage.getItem('phone');
    const phoneExpiry = sessionStorage.getItem('phoneExpiry');
    if (phone && phoneExpiry && Number(phoneExpiry) > Date.now()) {
      return phone;
    } else {
      this.clearPhone();
      return null;
    }
  }
  clearPhone() {
    sessionStorage.removeItem('phone');
    sessionStorage.removeItem('phoneExpiry');
    if (this.phoneSubject) {
      this.phoneSubject.next(null);
    }
  }
  getUserName(): string | null {
    return sessionStorage.getItem('userName');
  }
  getUserid(): string | null {
    return sessionStorage.getItem('id');
  }
  getUseremail(): string | null {
    return sessionStorage.getItem('useremail');
  }



  isAuthenticated(): Observable<boolean> {
    const token = sessionStorage.getItem('token');
    return new Observable<boolean>((observer) => {
      if (token) {
        observer.next(true);
      } else {
        observer.next(false);
      }
      observer.complete();
    });
  }

  login(credentials: { email: string; password: string }): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/api/auth/login`, credentials);
  }
  getPhoneDetails(phoneNumber: string): Observable<any> {
    const token = sessionStorage.getItem('token');
    if (!token) {
      console.error('Token is not available in sessionStorage');
      throw new Error('Token is missing in sessionStorage');
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    const body = { phoneNumber };
    return this.http.post<any>(`${this.apiUrl}/api/users/phone`, body, { headers });
  }
  getTransactionLogs(userId: string): Observable<any> {
    const token = sessionStorage.getItem('token');
    if (!token) {
      console.error('Token is not available in sessionStorage');
      throw new Error('Token is missing in sessionStorage');
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const body = { id: userId };
    return this.http.post(`${this.apiUrl}/api/users/transactionLog`, body, { headers });
  }
  getsmslogs(phoneNumber: string): Observable<any> {
    const token = sessionStorage.getItem('token');
    console.log("token", token);
    if (!token) {
      throw new Error('Token is missing in sessionStorage');
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const body = { phoneNumber };
    return this.http.post<any>(`${this.apiUrl}/api/users/smsLog`, body, { headers });
  }


  changePassword(email: string, requestBody: { oldPassword: string; newPassword: string; confirmPassword: string }): Observable<any> {
    const token = sessionStorage.getItem('token');
    if (!token) {
      console.error('Token is not available in sessionStorage');
      throw new Error('Token is missing in sessionStorage');
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const body = {
      email: email,
      ...requestBody,
    };
    return this.http.post(`${this.apiUrl}/api/users/change-password`, body, { headers });
  }
  deactivateUserActiveDevices(selectedUserId: string, rbtIsrc: any): Observable<any> {
    const token = sessionStorage.getItem('token');
    if (!token) {
      console.error('Token is not available in sessionStorage');
      throw new Error('Token is missing in sessionStorage');
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const body = {
      userId: selectedUserId,
      rbtIsrc: rbtIsrc
    };
    return this.http.post<any>(`${this.apiUrl}/api/users/song/deactivate`, body, { headers });
  }
  sendCurrencyId(id: number): Observable<any> {
    const token = sessionStorage.getItem('token');
    if (!token) {
      console.error('Token is not available in sessionStorage');
      throw new Error('Token is missing in sessionStorage');
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const payload = { id };
    return this.http.post<any>(`${this.apiUrl}/api/users/currency/subplan`, payload, { headers });
  }
  getSongs(): Observable<any> {
    const token = sessionStorage.getItem('token');
    if (!token) {
      console.error('Token is not available in sessionStorage');
      throw new Error('Token is missing in sessionStorage');
    }
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return this.http.get<any>(`${this.apiUrl}/api/users/songs`, { headers });
  }

  AddSongs(PhoneId: any, planId: any, musicId: any): Observable<any> {
    const token = sessionStorage.getItem('token');
    if (!token) {
      console.error('Token is not available in sessionStorage');
      throw new Error('Token is missing in sessionStorage');
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const body = {
      phone: PhoneId,
      planId: planId,
      songId: musicId
    };
    return this.http.post<any>(`${this.apiUrl}/api/users/song/add`, body, { headers });
  }
  logout(token: any): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return this.http.post<any>(`${this.apiUrl}/api/auth/logout`, {}, { headers }).pipe(
      tap(() => {
        // Clear the phone from sessionStorage after successful logout
        this.clearPhone();
      }),
      catchError((error) => {
        // Optionally handle any errors that occur during logout
        console.error('Logout failed:', error);
        return throwError(error);
      })
    );
  }
  clearAuthToken(): void {
    // Remove the authToken from sessionStorage
    sessionStorage.removeItem('token');

    // Clear the phone from sessionStorage
    this.clearPhone();
  }

  uploadExcelFile(file: File, type: any) {
    const token = sessionStorage.getItem('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(
      `${this.apiUrl}/api/users/transaction/upload?subType=${type}`,
      formData,
      { headers }
    );
  }

  getAllExcelResults(type: any) {
    const token = sessionStorage.getItem('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    return this.http.get(`${this.apiUrl}/api/users/transaction?subType=${type}`, { headers });
  }

  getExcelResultById(id: number) {
    const token = sessionStorage.getItem('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    return this.http.get(`${this.apiUrl}/api/users/transaction/details/${id}`, { headers });
  }

  downloadExcelResult(id: number) {
    const token = sessionStorage.getItem('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    return this.http.get(`${this.apiUrl}/api/users/transaction/details/download/${id}`, { headers, responseType: 'blob' });
  }

  downloadRawUploadedFile(id: number) {
    const token = sessionStorage.getItem('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    return this.http.get(`${this.apiUrl}/api/users/transaction/raw/download/${id}`, { headers, responseType: 'blob' });
  }

  downloadSampleExcel(type:AnimationPlaybackEvent) {
    const token = sessionStorage.getItem('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    return this.http.get(
      `${this.apiUrl}/api/users/transaction/download-format?subType=${type}`,
      { headers, responseType: 'blob' }
    );
  }

}
